import React from 'react';

import Menu, { LoaderMenu } from './views/menu/Menu';
import MenuForm, { LoaderMenuUpdate } from './views/menu/MenuForm';

import Media, { LoaderMedia } from './views/media/Media';

import Users, { LoaderUsers } from './views/users/Users';
import UsersForm, { LoaderUsersUpdate } from './views/users/UsersForm';

import Accounts, { LoaderAccounts } from './views/accounts/Accounts';
import AccountsForm, { LoaderAccountsUpdate } from './views/accounts/AccountsForm';

import ServiceOrders, { LoaderServiceOrders } from './views/service-orders/ServiceOrders';
import ServiceOrdersView, { LoaderServiceOrdersView } from './views/service-orders/ServiceOrdersView';
import LogHistoryRequests, { LoaderLogHistoryRequests } from './views/log-history/LogHistoryRequests';
import LogHistoryRequestsView, { LoaderLogHistoryRequestsView } from './views/log-history/LogHistoryRequestsView';

import Home from './views/home/Home';

import Settings from './views/settings/Settings';

import UsersNotifications, { LoaderUsersNotifications } from './views/user-notifications/UsersNotifications';
import UsersNotificationsVew, { LoaderUsersNotificationsVew } from './views/user-notifications/UsersNotificationsVew';
import MassiveNotificationsCreate from './views/massive-notifications/MassiveNotificationsCreate';
import MassiveNotifications, { LoaderMassiveNotifications } from './views/massive-notifications/MassiveNotifications';
import MassiveNotificationsView, { LoaderMassiveNotificationsView } from './views/massive-notifications/MassiveNotificationsView';
import UsersNotificationsForm from './views/user-notifications/UsersNotificationsForm';
import Roles, { LoaderRoles } from './views/roles/Roles';
import RolesForm, { LoaderRolesUpdate } from './views/roles/RolesForm';

import SupportCategories, { LoaderSupportCategories } from './views/support-categories/SupportCategories';
import SupportCategoriesForm from './views/support-categories/SupportCategoriesForm';
import SupportScopes, { LoaderSupportScopes } from './views/support-scopes/SupportScopes';
import SupportScopesForm from './views/support-scopes/SupportScopesForm';
import SupportTeams, { LoaderSupportTeams } from './views/support-teams/SupportTeams';
import SupportTeamsForm from './views/support-teams/SupportTeamsForm';
import SupportChannels, { LoaderSupportChannels } from './views/support-channels/SupportChannels';
import SupportChannelsForm from './views/support-channels/SupportChannelsForm';
import Qa, { LoaderQa } from './views/qa/Qa';
import QaForm from './views/qa/QaForm';
import Faq, { LoaderFaq } from './views/faq/Faq';
import FaqForm from './views/faq/FaqForm';
import SupportLetters, { LoaderSupportLetters } from './views/support-letters/SupportLetters';
import SupportLettersView, { LoaderSupportLettersView } from './views/support-letters/SupportLettersView';
import SupportLettersCreate from './views/support-letters/SupportLettersCreate';
import SupportLettersForm, { LoaderSupportLettersForm } from './views/support-letters/SupportLettersForm';
import SupportLettersSession, { LoaderSupportLettersSession } from './views/support-letters/SupportLettersSession';
import SupportLettersSessions, { LoaderSupportLettersSessions } from './views/support-letters/SupportLettersSessions';

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))

const Widgets = React.lazy(() => import('./views/widgets/Widgets'))
const Login = React.lazy(() => import('./views/pages/login/Login'))



/** ASD ROUTERS */
// const NewsForm = React.lazy(() => import('./views/news/NewsForm'))
const user = localStorage.getItem('user_data');


const routes = [
  { path: '/', exact: true, name: 'Home', element: <Home /> },
  { path: '/dashboard', name: 'Dashboard', element: <Dashboard /> },
  { path: '/widgets', name: 'Widgets', element: <Widgets /> },
  /** ASD Routers */

  { path: '/menu', name: 'Меню', element: <Menu user_data={user} />, loader: LoaderMenu },
  { path: '/menu/create', name: 'Створити меню', element: <MenuForm user_data={user} />, loader: LoaderMenuUpdate },
  { path: '/menu/update/:menuId', name: 'Редагувати меню', element: <MenuForm user_data={user} />, loader: LoaderMenuUpdate },
  { path: '/menu/children/:child_id', name: 'Редагувати меню', element: <MenuForm user_data={user} />, loader: LoaderMenuUpdate },

  { path: '/media', name: 'Медіа', element: <Media user_data={user} />, loader: LoaderMedia },

  { path: '/login', name: 'Логін', element: <Login /> },

  { path: '/users', name: 'Користувачі', element: <Users user_data={user} />, loader: LoaderUsers },
  { path: '/users/create', name: 'Створити користувача', element: <UsersForm user_data={user} />, loader: LoaderUsersUpdate },
  { path: '/users/view/:pid', name: 'Переглянути користувача', element: <UsersForm user_data={user} />, loader: LoaderUsersUpdate },

  { path: '/roles', name: 'Ролі', element: <Roles user_data={user} />, loader: LoaderRoles },
  { path: '/roles/create', name: 'Створити роль', element: <RolesForm user_data={user} />, loader: LoaderRolesUpdate },
  { path: '/roles/view/:id', name: 'Редагувати роль', element: <RolesForm user_data={user} />, loader: LoaderRolesUpdate },

  { path: '/support-categories', name: 'Категорії підтримки', element: <SupportCategories user_data={user} />, loader: LoaderSupportCategories },
  { path: '/support-categories/create', name: 'Нова категорія', element: <SupportCategoriesForm user_data={user} /> },
  { path: '/support-categories/view/:id', name: 'Переглянути категорію', element: <SupportCategoriesForm user_data={user} /> },
  { path: '/support-categories/update/:id', name: 'Редагувати категорію', element: <SupportCategoriesForm user_data={user} /> },

  { path: '/support-scopes', name: 'Область застосування', element: <SupportScopes user_data={user} />, loader: LoaderSupportScopes },
  { path: '/support-scopes/create', name: 'Нова область застосування', element: <SupportScopesForm user_data={user} /> },
  { path: '/support-scopes/view/:id', name: 'Переглянути область застосування', element: <SupportScopesForm user_data={user} /> },
  { path: '/support-scopes/update/:id', name: 'Редагувати область застосування', element: <SupportScopesForm user_data={user} /> },

  { path: '/support-teams', name: 'Команди', element: <SupportTeams />, loader: LoaderSupportTeams },
  { path: '/support-teams/create', name: 'Нова команда', element: <SupportTeamsForm user_data={user} /> },
  { path: '/support-teams/view/:id', name: 'Переглянути команду', element: <SupportTeamsForm user_data={user} /> },
  { path: '/support-teams/update/:id', name: 'Редагувати команду', element: <SupportTeamsForm user_data={user} /> },

  { path: '/support-channels', name: 'Канали зв\'язку', element: <SupportChannels />, loader: LoaderSupportChannels },
  { path: '/support-channels/create', name: 'Новий канал зв\'язку', element: <SupportChannelsForm user_data={user} /> },
  { path: '/support-channels/view/:id', name: 'Переглянути канал зв\'язку', element: <SupportChannelsForm user_data={user} /> },
  { path: '/support-channels/update/:id', name: 'Редагувати канал зв\'язку', element: <SupportChannelsForm user_data={user} /> },

  { path: '/qa', name: 'База знань (Q&A)', element: <Qa />, loader: LoaderQa },
  { path: '/qa/create', name: 'Новий запис Q&A', element: <QaForm user_data={user} /> },
  { path: '/qa/view/:id', name: 'Переглянути запис Q&A', element: <QaForm user_data={user} /> },
  { path: '/qa/update/:id', name: 'Редагувати запис Q&A', element: <QaForm user_data={user} /> },

  { path: '/faq', name: 'FAQ', element: <Faq />, loader: LoaderFaq },
  { path: '/faq/create', name: 'Новий FAQ-запис', element: <FaqForm user_data={user} /> },
  { path: '/faq/view/:id', name: 'Переглянути FAQ-запис', element: <FaqForm user_data={user} /> },
  { path: '/faq/update/:id', name: 'Редагувати FAQ-запис', element: <FaqForm user_data={user} /> },

  { path: '/support-letters', name: 'Листи', element: <SupportLetters />, loader: LoaderSupportLetters },
  { path: '/support-letters/create', name: 'Новий лист', element: <SupportLettersCreate user_data={user} /> },
  { path: '/support-letters/view/:id', name: 'Лист', element: <SupportLettersView user_data={user} />, loader: LoaderSupportLettersView },
  { path: '/support-letters/update/:id', name: 'Редагувати лист', element: <SupportLettersForm user_data={user} />, loader: LoaderSupportLettersForm },
  { path: '/support-letters/session/:id', name: 'Сесія листування', element: <SupportLettersSession user_data={user} />, loader: LoaderSupportLettersSession },
  { path: '/support-letters/sessions', name: 'Сесії листів', element: <SupportLettersSessions />, loader: LoaderSupportLettersSessions },

  { path: '/accounts', name: 'Особові рахунки', element: <Accounts user_data={user} />, loader: LoaderAccounts },
  { path: '/accounts/view/:pid', name: 'Переглянути особовий', element: <AccountsForm user_data={user} />, loader: LoaderAccountsUpdate },

  { path: '/service-orders', name: 'Заявки', element: <ServiceOrders user_data={user} />, loader: LoaderServiceOrders },
  { path: '/log-history-requests', name: 'Запити в додаток', element: <LogHistoryRequests user_data={user} />, loader: LoaderLogHistoryRequests },
  { path: '/service-orders/view/:pid', name: 'Переглянути заявку', element: <ServiceOrdersView user_data={user} />, loader: LoaderServiceOrdersView },
  { path: '/log-history-requests/view/:pid', name: 'Переглянути запит', element: <LogHistoryRequestsView user_data={user} />, loader: LoaderLogHistoryRequestsView },

  { path: '/user-notifications', name: 'Сповіщення користувачів', element: <UsersNotifications user_data={user} />, loader: LoaderUsersNotifications },
  { path: '/user-notifications/create', name: 'Нове сповіщення', element: <UsersNotificationsForm user_data={user} /> },
  { path: '/user-notifications/view/:pid', name: 'Переглянути сповіщення', element: <UsersNotificationsVew user_data={user} />, loader: LoaderUsersNotificationsVew },
  { path: '/massive-notifications', name: 'Масові сповіщення', element: <MassiveNotifications user_data={user} />, loader: LoaderMassiveNotifications },
  { path: '/massive-notifications/create', name: 'Створити сповіщення', element: <MassiveNotificationsCreate user_data={user} /> },
  { path: '/massive-notifications/view/:pid', name: 'Деталі масового сповіщення', element: <MassiveNotificationsView user_data={user} />, loader: LoaderMassiveNotificationsView },

  { path: '/settings', name: 'Налаштування користувача', element: <Settings user_data={user} /> },

]

export default routes
